import { __awaiter } from "tslib";
import { createStore } from '@souche-f2e/muji';
import APi from '@/services';
import { notification, Modal } from 'antd';
import { dispatch } from '@@/store';
import { uniqueArr } from '@/shared/functions';
import Mapping from '@/shared/mapping';
import { any } from 'prop-types';
const initData = {
    tableData: [],
    totalNumber: 0,
    pageCurrent: 1,
    pageSize: 20,
    refreshCurrentTable: 0,
    saveCurrentPage: 1,
    searchData: {},
    picCount: 0,
    // 发起确认过户
    showPayConfirm: false,
    tempObj: any,
    visibleDaYuModal: false,
    actionType: 0,
    orderTag: 0,
    resource: 0,
    getTruth: false,
    elasticFrameVisible: false,
    elasticFrameVisibles: false,
    transferType: 0,
    transferFrozenMoney: 0,
    forbiddenButton: false,
    waitValue: 10,
    getUploadPicData: [],
    visible: false,
    transferDataJson: {},
    isShow: false,
    orderId: '',
    carVin: '',
    lable: '',
    id: '',
    num: 0,
    commonTransferType: 0,
    orderTransferType: 0,
    text: '',
    checkTransferData: {},
    goodsId: '',
    exportObjParams: {},
    propsCallback: () => { },
};
export default createStore({
    state: Object.assign({}, initData),
    effects: {
        // desc 更新表格
        updateTable(index, { state }) {
            const { searchData, pageCurrent, pageSize } = state;
            const searchParams = {
                provinceCode: searchData && searchData.provinceCode ? searchData.provinceCode : '',
                cityCode: searchData && searchData.cityCode ? searchData.cityCode : '',
                license: searchData && searchData.license ? searchData.license : '',
                sellerPhone: searchData && searchData.sellerPhone ? searchData.sellerPhone : '',
                vinCode: searchData && searchData.vinCode ? searchData.vinCode : '',
                buyerName: searchData && searchData.buyerName ? searchData.buyerName : '',
                sellerCode: searchData && searchData.sellerCode ? searchData.sellerCode : '',
                buyerPhone: searchData && searchData.buyerPhone ? searchData.buyerPhone : '',
                buyerPayDateStar: searchData && searchData.startTime ? searchData.startTime : '',
                buyerPayDateEnd: searchData && searchData.endTime ? searchData.endTime : '',
                buyerTypeCode: searchData && searchData.buyerTypeCode,
                sourceType: searchData && searchData.sourceType,
                pageSize,
                pageCurrent: index ? index : pageCurrent + 1,
            };
            APi.order.WaitTransferCarList(searchParams).then((res) => {
                this.SET_STATE({
                    tableData: uniqueArr(res.items),
                    totalNumber: res.totalNumber,
                    pageCurrent: res.currentIndex,
                    exportObjParams: Object.assign(Object.assign({}, searchParams), { totalCount: res.totalNumber, exportType: Mapping.excelExportType.order_wait_transfer.value }),
                });
            });
        },
        // desc 重置数据
        resetState(params) {
            this.SET_STATE(Object.assign(Object.assign({}, initData), params));
        },
        refreshCurrentPage({ state, rootState }) {
            const { saveCurrentPage } = rootState.router.query;
            const tableDataLength = state.tableData.length - 1;
            if (saveCurrentPage) {
                if (saveCurrentPage !== 1) {
                    if (tableDataLength === 0) {
                        this.updateTable(saveCurrentPage - 1);
                    }
                    else {
                        this.updateTable(saveCurrentPage);
                    }
                }
                else {
                    this.updateTable(saveCurrentPage);
                }
            }
            else {
                if (state.pageCurrent !== 1) {
                    if (tableDataLength === 0) {
                        this.updateTable(state.pageCurrent - 1);
                    }
                    else {
                        this.updateTable(state.pageCurrent);
                    }
                }
                else {
                    this.updateTable(state.pageCurrent);
                }
            }
        },
        // desc申请向卖家付款
        agree({ data, callback }) {
            Modal.confirm({
                title: '是否确定申请向卖家付款',
                onOk() {
                    dispatch.transfer.applyToSellerPay({
                        idList: data,
                    }).then(() => {
                        callback();
                    });
                },
            });
        },
        // 申请向卖家付款
        applyToSellerPay({ idList, callback }, { state, rootState }) {
            APi.order.applicationSellerPay({ orderIds: JSON.stringify(idList) }).then((res) => {
                if (res) {
                    notification.success({ message: '向卖家申请付款成功' });
                    // this.refreshCurrentPage({ state, rootState });
                }
            }).catch((err) => {
                notification.error({ message: '向卖家申请付款失败' });
            });
        },
        // 获取扣减用户保证金金额
        getAuctionBaseInfo(rowData, { state }) {
            const auctionId = rowData;
            APi.auction.getAuctionBaseInfo({ auctionId }).then((res) => {
                if (res) {
                    this.SET_STATE({
                        transferFrozenMoney: res.breakFrozenMoney,
                    });
                }
            });
        },
        // desc确认过户弹框
        comfirmTransfer(form, { state, rootState }) {
            // transferMode为0，针对老数据的处理方式
            if (state.commonTransferType === 30) {
                state.transferDataJson.transferType = state.waitValue;
            }
            APi.order.saveTransInfo({ transferDataJson: JSON.stringify(state.transferDataJson) })
                .then((data) => {
                if (data) {
                    notification.success({ message: '添加成功' });
                    this.HIDE_ADD_MODAL(state);
                    this.SET_STATE({
                        transferDataJson: {},
                    });
                }
            }).catch((e) => {
                this.SET_STATE({
                    transferDataJson: {},
                });
            });
            // transferMode: 过户类型: 3 | 2 | 0 ==> 买家 | 卖家 | 老数据没有售后信息
            // 老数据
            if (form.transferMode === 0) {
                const params = {
                    orderId: form.orderId,
                    goodsId: form.goodsId,
                    deductState: 0,
                    remark: '',
                    transferType: form.transferType,
                };
                APi.order.comfirmTransferCar(params)
                    .then((res) => {
                    if (res) {
                        // 操作成功 重新获取当前页列表
                        notification.success({ message: '确认过户成功' });
                        this.refreshCurrentPage({ state, rootState });
                        state.propsCallback();
                    }
                }).catch((err) => {
                    this.refreshCurrentPage({ state, rootState });
                    state.propsCallback();
                });
            }
            else {
                form.validateFields((error, values) => {
                    if (!error) {
                        const params = {
                            orderId: state.id,
                            goodsId: state.goodsId,
                            deductState: values.isTrue || 0,
                            remark: values.disputeReason,
                            transferType: ((values.disputeInfo === 10 || values.disputeInfo === 20) ? values.disputeInfo : state.transferType),
                        };
                        APi.order.comfirmTransferCar(params)
                            .then((res) => {
                            if (res) {
                                this.refreshCurrentPage({ state, rootState });
                                state.propsCallback();
                            }
                        })
                            .catch(() => {
                            this.refreshCurrentPage({ state, rootState });
                            state.propsCallback();
                        });
                    }
                });
            }
        },
        // desc提交过户信息
        updateTransfers(form, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                // transferMode为0，针对老数据的处理方式
                const params = {
                    orderId: form.orderId,
                    goodsId: form.goodsId,
                    deductState: 0,
                };
                yield APi.order.comfirmTransferCar(params)
                    .then((res) => {
                    if (res) {
                        // 操作成功 重新获取当前页列表
                        notification.success({
                            message: '确认过户成功',
                        });
                    }
                });
            });
        },
        // 查询确认过户信息
        checkTransInfo(params, { state }) {
            APi.order.queryTransferInfo({ orderId: params.id, carVin: params.carVin }).then((data) => {
                if (data) {
                    this.SET_STATE({
                        checkTransferData: data,
                        orderTransferType: data.transferType,
                    });
                }
            });
        },
        // 买方和卖方同意和驳回图片
        buyTransData(params, { state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                yield APi.order.buyTransData({ transferDataJson: JSON.stringify(params) }).then((data) => {
                    if (data) {
                        // this.refreshCurrentPage({ state, rootState });
                        // this.SET_STATE({
                        //   refreshCurrentTable: rootState.router.query.saveCurrentPage,
                        // });
                        // dispatch.router.push({
                        //   path: '/OrderManage',
                        // });
                        dispatch.router.go(-1);
                    }
                    else {
                        notification.warn({
                            message: '状态已变更，请刷新',
                        });
                    }
                });
            });
        },
        // 提交修改过的过户手续资料
        getUploadPicTempl(val, { state }) {
            const { orderId } = val;
            APi.order.getUploadPicTempl({ orderId }).then((data) => {
                if (data) {
                    // data.modelGroup.map((item:any, index:any) => {
                    //   item.picGroup = [];
                    // });
                    this.SET_STATE({
                        getUploadPicData: data,
                        commonTransferType: data.transferType,
                    });
                }
            });
        },
        // 待过户确认窗口
        showPayConfirm(payload) {
            this.SET_STATE({
                price: payload.brokerageYuanUnit,
                orderId: payload.orderId,
                showPayConfirm: true,
            });
        },
        // 确认交车-等待卖家上传手续中
        confirmGiveCar(val, { state }) {
            const { orderId } = val;
            return APi.order.confirmGiveCar({ orderId }).then((data) => {
                if (data) {
                    this.SET_STATE({
                        getTruth: data,
                    });
                }
            });
        },
        // 保存卖方上传的图片
        updateData(initData, { state }) {
            // 当用户为不限时。让用户选择本地或者外迁
            let warnInfo = false;
            let totalNum = 0;
            let lCount = 0;
            if (state.commonTransferType === 10) {
                initData.modelGroup.map((item) => {
                    if (item.lRequired) {
                        if (item.picGroup.length === 0) {
                            lCount += 1;
                        }
                    }
                    totalNum += item.picGroup.length;
                    this.SET_STATE({
                        picCount: totalNum,
                    });
                });
            }
            else if (state.commonTransferType === 20) {
                initData.modelGroup.map((item) => {
                    if (item.eRequired) {
                        if (item.picGroup.length === 0) {
                            lCount += 1;
                        }
                    }
                    totalNum += item.picGroup.length;
                    this.SET_STATE({
                        picCount: totalNum,
                    });
                });
            }
            else if (state.commonTransferType === 30) {
                if (state.waitValue === 10) {
                    initData.modelGroup.map((item) => {
                        if ((item.picTransferType === 0 || item.picTransferType === 10)) {
                            if (item.lRequired) {
                                if (item.picGroup.length === 0) {
                                    lCount += 1;
                                }
                            }
                        }
                        totalNum += item.picGroup.length;
                        this.SET_STATE({
                            picCount: totalNum,
                        });
                    });
                }
                else if (state.waitValue === 20) {
                    initData.modelGroup.map((item) => {
                        if ((item.picTransferType === 0 || item.picTransferType === 20)) {
                            if (item.eRequired) {
                                if (item.picGroup.length === 0) {
                                    lCount += 1;
                                }
                            }
                        }
                        totalNum += item.picGroup.length;
                        this.SET_STATE({
                            picCount: totalNum,
                        });
                    });
                }
            }
            if (lCount !== 0) {
                warnInfo = true;
            }
            else {
                warnInfo = false;
            }
            if (warnInfo) {
                notification.warn({
                    message: '请上传相关过户信息',
                });
            }
            else {
                this.HIDE_ADD_MODAL(state);
                this.SET_STATE({
                    transferDataJson: initData,
                    forbiddenButton: true,
                });
            }
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
        // 隐藏卖方过户信息弹框
        HIDE(state) {
            state.visible = false;
        },
        // 存储--选择本地或者外迁的过户信息
        CHANGE_VALUE(state, obj) {
            state.waitValue = obj;
        },
        // 显示卖方过户信息弹框
        OK(state) {
            state.visible = false;
        },
        // 展示添加过户信息弹框且保存ID等信息
        SHOW(state, { id, goodsId, transferType, actionType, orderTag, actionId, propsCallback }) {
            state.visible = true;
            state.isShow = true;
            state.id = id;
            state.goodsId = goodsId;
            state.transferType = transferType;
            state.actionType = actionType;
            state.orderTag = orderTag;
            state.propsCallback = propsCallback;
        },
        // 保存确认过户的驳回信息
        PASS_TEXT(state, obj) {
            const { transIndex, transIdx, text } = obj;
            state.checkTransferData.modelGroup[transIndex].picGroup[transIdx].remark = text;
        },
        // 存储过户信息数据
        SAVE_UPDATE_DATA(state, tempObj) {
            state.tempObj = tempObj;
        },
        // 显示确认过户的驳回信息弹框
        SHOW_REMARK_EDIT(state) {
            state.elasticFrameVisible = true;
        },
        // 显示添加过户信息弹框
        SHOW_ADD_MODAL(state, index) {
            state.elasticFrameVisibles = true;
        },
        // 隐藏添加过户信息弹框
        HIDE_ADD_MODAL(state, index) {
            state.elasticFrameVisibles = false;
        },
        // 隐藏确认过户的驳回信息弹框
        HIDE_REMARK_EDIT(state) {
            state.elasticFrameVisible = false;
        },
        // 确认过户--type为1，直接走接口，type为2时走弹框
        CONFIRM_RESOURCE(state, type) {
            state.resource = Number(type);
        },
        // 判断来源方，然后分发数据
        CONFIRM_REQUEST(state, type) {
            switch (type) {
                case 'seller':
                    state.lable = '提交过户信息';
                    state.num = 1;
                    break;
                case 'buyer':
                    state.lable = '确认过户';
                    state.num = 2;
                    break;
                default:
                    state.lable = '';
            }
        },
    },
});
